<script setup>
import { iscrizioniPage } from '@/graphql/queries/iscrizioni.js'

definePageMeta({
  layout: 'default',
})

const { locale } = useI18n()

const variables = computed(() => ({
  locale: locale.value,
}))

const { data } = await useGraphql(iscrizioniPage, variables)

if (!data.value.paginaIscrizioni) {
  throw createError({ statusCode: 404 })
}

const page = computed(() => data?.value?.paginaIscrizioni || {})

const seo = computed(() => page?.value?.seo || {})

useSeo(seo)
</script>

<template>
  <div class="iscrizioni-page">
    <LazyPagineIscrizioniHero :hero="page.hero" />
    <div class="p-top-xxl-2 row-400-25-default max-content">
      <LazyImgTextCardsOrdered :block="page.immagineTesto" />
    </div>
    <LazyPagineIscrizioni />
  </div>
</template>

<script>
export default {
  name: 'IscrizioniPage',
}
</script>
